/**
 * Derives the operational region (East, West, Central) from a US venue address.
 * Falls back to undefined for international or unrecognizable addresses.
 */

const EAST_STATES = new Set([
  // Northeast
  "connecticut", "ct", "delaware", "de", "maine", "me", "maryland", "md",
  "massachusetts", "ma", "new hampshire", "nh", "new jersey", "nj",
  "new york", "ny", "pennsylvania", "pa", "rhode island", "ri", "vermont", "vt",
  // Southeast
  "alabama", "al", "florida", "fl", "georgia", "ga", "kentucky", "ky",
  "mississippi", "ms", "north carolina", "nc", "south carolina", "sc",
  "tennessee", "tn", "virginia", "va", "west virginia", "wv",
  "district of columbia", "dc", "washington dc", "washington d.c.",
]);

const WEST_STATES = new Set([
  "alaska", "ak", "arizona", "az", "california", "ca", "colorado", "co",
  "hawaii", "hi", "idaho", "id", "montana", "mt", "nevada", "nv",
  "new mexico", "nm", "oregon", "or", "utah", "ut", "washington", "wa",
  "wyoming", "wy",
]);

const CENTRAL_STATES = new Set([
  "arkansas", "ar", "illinois", "il", "indiana", "in", "iowa", "ia",
  "kansas", "ks", "louisiana", "la", "michigan", "mi", "minnesota", "mn",
  "missouri", "mo", "nebraska", "ne", "north dakota", "nd", "ohio", "oh",
  "oklahoma", "ok", "south dakota", "sd", "texas", "tx", "wisconsin", "wi",
]);

export function detectRegionFromAddress(address: string | undefined | null): string | undefined {
  if (!address) return undefined;
  const lower = address.toLowerCase();

  // Try matching state names and abbreviations from the address
  // We check longer names first to avoid partial matches
  for (const state of EAST_STATES) {
    if (lower.includes(state)) return "East";
  }
  for (const state of WEST_STATES) {
    if (lower.includes(state)) return "West";
  }
  for (const state of CENTRAL_STATES) {
    if (lower.includes(state)) return "Central";
  }

  return undefined;
}
